import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"


import Seo from "../components/SEO"
import "../styles/new.css"
import "../styles/mobilenew.css"
import im1 from "../images/expph/exterior7wooden.jpg"


const WoodenCastle = () => {


    return (
        <>

            <Seo
                title="Wooden Castle"
                description="A case study of luxurious remake of wooden castle."
                image={im1}
            />

            <div className="section">
                <h3 className="centerthis">WOODEN CASTLE</h3>
            </div>


            <div className="section">

                <StaticImage placeholder="dominantColor" className="image maxdim" src="../images/expph/exterior7wooden.jpg" alt="exterior7wooden" />
            </div>




            <div className="centerthis casestudytestimonial">
                <article className="article">
                    <p>" Nolan Interiors has a great team, friendly relation, they designed the ideal
                        house for my needs. It is a fantastic project, we are very happy! They were
                        originally recommended to us by a friend and now we recommend them. "</p>
                    <h4>Mr. & Mrs. Starks </h4>
                </article>

            </div>


            <div className="section">
                <div className="portfolioitemgrid">

                    <div className="ltop"><StaticImage placeholder="dominantColor" className="image" src="../images/wd/h1.jpg" alt="exterior7wooden" /></div>
                    <div className="centerthis mobilemargins">
                        <article className="article ">

                            <p>Wooden Castle is a relatively new establishment and very fantastical in its feel and looks.
                            </p>
                        </article>
                    </div>


                    <div className="rbottom"><StaticImage placeholder="dominantColor" className="image" src="../images/wd/h2.jpg" alt="exterior7wooden" /></div>

                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>When I was first introduced to the idea, I realised right away it was a dream more than the house.</p>
                        </article>
                    </div>



                </div>
            </div>



            <div className="section">
                <div className="portfolioitemgrid">

                    <div className="rtop"><StaticImage placeholder="dominantColor" className="image" src="../images/wd/h3.jpg" alt="exterior7wooden" /></div>

                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>The wooden Castle was a country cottage made with the intention of a perfect vacation getaway.</p>
                        </article>
                    </div>

                    <div className="lbottom"><StaticImage placeholder="dominantColor" className="image" src="../images/wd/h4.jpg" alt="exterior7wooden" /></div>
                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>The owners wanted us to redesign the interiors keeping the intention in our mind all the time.</p>
                        </article>
                    </div>


                </div>
            </div>


            <div className="section">
                <div className="portfolioitemgrid">

                    <div className="ltop"><StaticImage placeholder="dominantColor" className="image" src="../images/wd/h5.jpg" alt="exterior7wooden" /></div>
                    <div className="centerthis mobilemargins">
                        <article className="article ">

                            <p>What stood out the most for me was how spacious the place looked with a single small room and a hall with no furniture. </p>
                        </article>
                    </div>


                    <div className="rbottom"><StaticImage placeholder="dominantColor" className="image" src="../images/wd/h6.jpg" alt="exterior7wooden" /></div>

                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>I had decided beforehand that the wooden textures of this place would be the key element in creating warmth and coziness.
                            </p>
                        </article>
                    </div>



                </div>
            </div>



            <div className="section">
                <div className="portfolioitemgrid">

                    <div className="rtop"><StaticImage placeholder="dominantColor" className="image" src="../images/wd/h7.jpg" alt="exterior7wooden" /></div>

                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>The greatest element was the fireplace - the traditional open hearth made the place look just the right part fantasy and right part reality.
                            </p>
                        </article>
                    </div>

                    <div className="lbottom"><StaticImage placeholder="dominantColor" className="image" src="../images/wd/h8.jpg" alt="exterior7wooden" /></div>
                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>Next,  instead of using modern furniture, we resorted to a love seat and wicker chair for giving it a cozy, inviting feel.</p>
                        </article>
                    </div>


                </div>
            </div>


            <div className="section">
                <div className="portfolioitemgrid">

                    <div className="ltop"><StaticImage placeholder="dominantColor" className="image" src="../images/wd/h9.jpg" alt="exterior7wooden" /></div>
                    <div className="centerthis mobilemargins">
                        <article className="article ">

                            <p>My vision of the perfect getaway vacation home was realised when finally we had the right little sculpture to add above the fireplace hearth. </p>
                        </article>
                    </div>


                    <div className="rbottom"><StaticImage placeholder="dominantColor" className="image" src="../images/wd/v1.jpg" alt="exterior7wooden" /></div>

                    <div className="centerthis mobilemargins">
                        <article className="article">

                            <p>The success of this project was marked by the client's comment about the "perfect home for escaping reality."
                            </p>
                        </article>
                    </div>



                </div>
            </div>






            <Link to="/cafe-mania">
                <div className="section">
                    <h3 className="centerthis"><u>NEXT PROJECT</u></h3>
                </div>

            </Link>







        </>

    )
}

export default WoodenCastle

